export const firstWordUppercase = (word) => {
  return word[0].toUpperCase() + word.substring(1)
}
